import React, { FunctionComponent } from 'react';
import { Container } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { withRouter, match } from 'react-router';
import { compose } from 'recompose';
import { path } from 'ramda';

import { useDatePicker } from 'components/DatePicker/DatePicker.context';
import { ClassProp } from 'helpers/types';

import StatisticSection from 'scenes/Home/components/VenueDetails/sections/StatisticSection';
import CardSection from 'scenes/Home/components/VenueDetails/sections/CardSection';
import ChartSection from 'scenes/Home/components/VenueDetails/sections/ChartSection';

import HeaderSection from './sections/HeaderSection';

const styles = {
  container: {
    margin: '12rem auto !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  match: match;
};

const VenusStatusDetail: FunctionComponent<Props> = ({ classes, match }) => {
  const merchantId = path(['params', 'merchantId'], match) as string;
  const venueUuid = path(['params', 'venueId'], match) as string;
  const { startDate, endDate } = useDatePicker();
  const params = {
    merchantId,
    venueUuid,
    startDate,
    endDate,
  };

  return (
    <Container className={classes.container}>
      <HeaderSection variables={{ venueUuid }} />
      <StatisticSection variables={{ params }} />
      <CardSection variables={{ venueUuid }} />
      <ChartSection variables={{ params }} />
    </Container>
  );
};

export default compose<Props, any>(
  withStyles(styles),
  withRouter,
)(VenusStatusDetail);
